export default __webpack_public_path__ + "static/media/banner1.9ea02767.jpg";